import { Store } from 'Application/Store/Store'
let
    initialX = null,
    initialY = null,
    timeout,
    _startTouch = null,
    _moveTouch = null

/**
 * initialize touch position
 * @params {object} event - click event
 */
const startTouch = event => {
    initialX = event.touches[0].clientX
    initialY = event.touches[0].clientY
}

/**
 * update finger position and dispatch gesture event
 * @params {object} event - move event
 * @params {object} specs - an array of different spec
 */
const isInsideScrollableSpecs = target => {
    if (!target) return false;
    let node = target;
    while (node) {
        if (node.classList && (node.classList.contains('mobile-scroll-wrapper') || node.classList.contains('specsMobile') || node.classList.contains('specsDesktop') || node.id === 'footerContainer')) {
            return true;
        }
        node = node.parentElement;
    }
    return false;
};

const moveTouch = (event, specs) => {

    if (initialX !== null && initialY !== null) {

        // Ignore swipe between tabs if user is scrolling inside a specs table
        if (event.target && isInsideScrollableSpecs(event.target)) {
            initialX = null;
            initialY = null;
            return;
        }

        let
            currentX = event.touches[0].clientX,
            currentY = event.touches[0].clientY,
            diffX = initialX - currentX,
            diffY = initialY - currentY

        if (!timeout) {
            timeout = setTimeout(() => {
                if (Math.abs(diffX) > Math.abs(diffY)) {
                    const
                        activatedIndex = specs.indexOf(Store.getState().ViewportReducer.footerVisibility),
                        payload = diffX > 0 ?
                            specs[(activatedIndex +1) > (specs.length -1) ? 0 : activatedIndex + 1] :
                            specs[(activatedIndex -1) === -1 ? (specs.length -1) : activatedIndex -1]

                    Store.dispatch({ type: 'CLOSE_LIVE', payload: null })
                    Store.dispatch({
                        type: 'FOOTER_VISIBLE',
                        payload
                    })

                }
                timeout = null;
            }, 200)
        }
        initialX = null
        initialY = null
    }
}


/**
 * subcribe gesture event
 */
export const gesturesUnsubscribe = () => {
    if (_startTouch) {
        document.removeEventListener('touchstart', _startTouch)
        _startTouch = null
    }
    if (_moveTouch) {
        document.removeEventListener('touchmove', _moveTouch)
        _moveTouch = null
    }
    if (timeout) {
        clearTimeout(timeout)
        timeout = null
    }
}


/**
 * unsubscibe gesture event
 */
export const gesturesSubscribe = specsActive => {
    gesturesUnsubscribe()
    _startTouch = startTouch
    _moveTouch = e => moveTouch(e, specsActive)
    document.addEventListener('touchstart', _startTouch)
    document.addEventListener('touchmove', _moveTouch)
}
